<template>
  <section v-home-reveal class="palettes" :aria-label="t('paletteExplorerText')">
    <div class="palettes-copy">
      <h2>{{ t('paletteExplorerText') }}</h2>
      <p>{{ t('paletteExplorerSubText') }}</p>
    </div>

    <div class="scene">
      <img class="backdrop" :src="choice.src" :alt="t(choice.captionKey)" />

      <div class="set is-left">
        <figure v-for="palette in leftPalettes" :key="palette.titleKey">
          <div class="photo">
            <img :src="palette.src" :alt="t(palette.titleKey)" />
          </div>
          <figcaption>{{ t(palette.titleKey) }}</figcaption>
        </figure>
      </div>

      <div class="set is-right">
        <figure v-for="palette in rightPalettes" :key="palette.titleKey">
          <div class="photo">
            <img :src="palette.src" :alt="t(palette.titleKey)" />
          </div>
          <figcaption>{{ t(palette.titleKey) }}</figcaption>
        </figure>
      </div>

      <router-link class="scene-cta" to="/signUp">{{ t(choice.captionKey) }}</router-link>
    </div>
  </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { HOME_PALETTE_CHOICE, HOME_PALETTES } from './home.data';
import { vHomeReveal } from './home-reveal';

export default defineComponent({
  directives: {
    homeReveal: vHomeReveal,
  },
  setup() {
    const { t } = useI18n();

    return {
      t,
      leftPalettes: HOME_PALETTES.slice(0, 6),
      rightPalettes: HOME_PALETTES.slice(6),
      choice: HOME_PALETTE_CHOICE,
    };
  },
});
</script>
<style scoped lang="scss">
.palettes {
  margin: 8px 0 72px;
}

.palettes-copy {
  margin: 0 auto 22px;
  max-width: 42ch;
  text-align: center;
}

.palettes-copy h2 {
  margin: 0 0 10px;
  font-size: clamp(1.55rem, 3.2vw, 2.2rem);
  font-weight: 600;
  letter-spacing: -0.04em;
}

.palettes-copy p {
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: rgba(246, 243, 238, 0.76);
}

.scene {
  position: relative;
  overflow: hidden;
  isolation: isolate;
  border-radius: 28px;
  aspect-ratio: 16 / 9;
  border: 1px solid rgba(246, 243, 238, 0.12);
  background: #f6f3ee;
}

.backdrop {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 42%;
}

.set {
  position: absolute;
  top: 50%;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
  width: min(32%, 300px);
  transform: translateY(-50%);
}

.is-left {
  left: 18px;
}

.is-right {
  right: 18px;
}

.set figure {
  margin: 0;
  text-align: center;
  transition: transform 0.35s ease;
}

.set figure:hover {
  z-index: 2;
  transform: scale(1.06);
}

.photo {
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: 50%;
  background: #f6f3ee;
  box-shadow: 0 6px 16px rgba(20, 16, 24, 0.18);
}

.photo img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.set figcaption {
  margin-top: 6px;
  font-size: 10px;
  letter-spacing: 0.08em;
  line-height: 1.2;
  text-transform: uppercase;
  color: #2c2723;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.7);
}

.scene-cta {
  position: absolute;
  left: 50%;
  bottom: 16px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  text-decoration: none;
  color: #f6f3ee;
  background: #141018;
  box-shadow: 0 8px 20px rgba(20, 16, 24, 0.28);
  transform: translateX(-50%);
  transition: transform 0.3s ease, background 0.3s ease;
}

.scene-cta:hover {
  background: #1c181f;
  transform: translateX(-50%) translateY(-2px);
}

@media (max-width: 860px) {
  .scene {
    aspect-ratio: 4 / 5;
  }

  .set {
    width: 28%;
    gap: 8px 6px;
  }

  .is-left {
    left: 10px;
  }

  .is-right {
    right: 10px;
  }

  .set figcaption {
    font-size: 8px;
    letter-spacing: 0.04em;
  }

  .scene-cta {
    bottom: 12px;
    padding: 7px 12px;
    font-size: 10px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .set figure,
  .scene-cta {
    transition: none;
  }

  .set figure:hover {
    transform: none;
  }

  .scene-cta:hover {
    transform: translateX(-50%);
  }
}
</style>
